export const DefaultOptions = {
  tabWidth: 4,
}

export default async function convertTabsToSpaces(input, options={}) {
  const {tabWidth} = {...DefaultOptions, ...options}

  return input.replaceAll('\t', ' '.repeat(tabWidth))
}
